/**
 * Import Bootstrap JS
 */
import * as bootstrap from 'bootstrap';

// ...or individually as
//import Alert from 'bootstrap/js/dist/alert'
// ...or, specify which plugins you need:
//import { Alert, Tooltip, Toast, Popover } from 'bootstrap';


/**
 * Example exports for testing via Jest
 */
module.exports = {
  exampleSum: function (a, b) { return a+b; },
  isJqueryLoaded: (typeof jQuery === 'function' || typeof $ === 'function'),
  isBootstrapLoaded: (typeof jQuery().modal === 'function'),
}


/**
 * Document Ready Functions
 */
jQuery(document).ready(function($) {
  
  /**
   * Mobile Menu Toggler
   */
  $('#mobile-menu-button').on('click',function(e){
    e.preventDefault();

    // Toggle the active class
    $('body').toggleClass('mobile-menu-active');
    $(this).toggleClass('is-active');

    // Aria toggles
    $(this).attr('aria-expanded', function (i, attr) {
      return attr == 'true' ? 'false' : 'true'
    });

    // Text Toggler
    var text = $('#mobile-menu-button .hamburger-text').text();
    $('#mobile-menu-button .hamburger-text').text(text == 'Menu' ? 'Close' : 'Menu');
  });

  /**
   * Close mobile menu on jump link clicks
   */
  $('#mobile-menu a').on('click', function(){
    $('body').removeClass('mobile-menu-active');
    $('#mobile-menu-button').removeClass('is-active').attr('aria-expanded', 'false');
    $('#mobile-menu-button .hamburger-text').text('Menu');
  });

});